import PageContent from "../../components/PageContent";
import {useQuery} from "react-query";
import {getContests} from "../../api/Contests";
import styled from "styled-components";
import {ContestItem} from "./components/ContestItem";
import {useMemo, useState} from "react";
import {Pagination} from "antd";

const Background = styled.div`
  position: relative;
  min-height: 290px;
  background-image: url(${require('../../assets/images/contests-bg.png')});
  background-size: auto 100%;
  background-position: center;
  border-radius: 5px;
  padding: 77px 56px 36px;
  @media screen and (max-width: 768px) {
    padding: 33px 31px 36px;
  }
`

const Title = styled.div`
  display: block;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 24px;
  @media screen and (max-width: 768px) {
    font-size: 13px;
  }
`
const Summary = styled.div`
  margin-top: 42px;
  font-size: 13px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 24px;
  @media screen and (max-width: 768px) {
    margin-top: 21px;
    font-size: 12px;
  }
`

const PaginationWrap = styled.div`
  margin-top: 20px;
  text-align: right;
`

export const Contests = () => {
     const [page, setPage] = useState(1)
    const {data} = useQuery(['contests', page], () => getContests({
        currentPage: page,
        pageSize: 10,
    }))

    const contests = useMemo(() => {
        return data?.data?.contests ?? {
            list: [],
            total: 0
        }
    }, [data])

    const text = useMemo(() => {
        return {
            title: data?.data?.title ?? '',
            summary: data?.data?.summary ?? '',
        }
    }, [data])

    return (
        <PageContent>
            <Background>
                <Title>{text.title}</Title>
                <Summary>{text.summary}</Summary>
            </Background>
            {
                contests.list.map(item => (
                    <ContestItem key={item.id} contest={item} />
                ))
            }
            <PaginationWrap>
                <Pagination current={page} onChange={(page) => setPage(page)} total={contests.total} />
            </PaginationWrap>
        </PageContent>
    )
}